import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { connectWithSocketIOServer } from "./utils/wss";
import IntroductionPage from "./IntroductionPage/IntroductionPage";
import JoinRoomPage from "./JoinRoomPage/JoinRoomPage";
import RoomPage from "./RoomPage/RoomPage";
import { authStateListener, getAuthResult } from "./firebase";
import { setUser, setAuthError } from "./store/actions";
import { connect } from "react-redux";
import "./App.css";

function App({ setUserAction, setAuthErrorAction }) {
  useEffect(() => {
    // Connect to socket server
    connectWithSocketIOServer();

    // Check for redirect auth result (needed for WebView)
    getAuthResult()
      .then((userData) => {
        if (userData) {
          console.log('[App] Auth result from redirect:', userData.uid);
          setUserAction(userData);
        }
      })
      .catch((error) => {
        console.error('[App] Error getting auth result:', error);
      });

    // Set up Firebase auth state listener with error handling
    const unsubscribe = authStateListener(
      (user) => {
        console.log('[App] Auth state changed:', user ? user.uid : 'null');
        setUserAction(user);
      },
      (error) => {
        console.error('[App] Auth state listener error:', error);
        // Handle the "missing initial state" error specifically
        if (error.code === 'auth/internal-error' &&
          (error.message?.includes('missing initial state') ||
            error.message?.includes('state'))) {
          console.warn('[App] Detected "missing initial state" error - likely due to storage partitioning or WebView');
          setAuthErrorAction('Your browser or WebView is preventing authentication. Please try: 1) Opening in a regular browser, 2) Disabling tracking protection for this site, 3) Allowing cookies for this site.');
        } else {
          setAuthErrorAction(error.message);
        }
      }
    );

    // Cleanup listener on unmount
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [setUserAction, setAuthErrorAction]);

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={IntroductionPage} />
        <Route path="/join-room" component={JoinRoomPage} />
        <Route path="/room" component={RoomPage} />
      </Switch>
    </Router>
  );
}

const mapActionsToProps = (dispatch) => {
  return {
    setUserAction: (user) => dispatch(setUser(user)),
    setAuthErrorAction: (error) => dispatch(setAuthError(error)),
  };
};

export default connect(null, mapActionsToProps)(App);
